export const WORKER_TYPE = 'calculateProbabilityWorker';
